export { default as VictorySharedEvents } from "./victory-shared-events";


//////////////////
// WEBPACK FOOTER
// ./~/victory-shared-events/es/index.js
// module id = ./node_modules/victory-shared-events/es/index.js
// module chunks = 1